import { Controller } from '@hotwired/stimulus'

/**
 * Видео с YouTube «по клику» (shared/_youtube_video).
 *
 * До клика на странице только своя картинка-обложка и кнопка: плеер YouTube
 * тянет за собой мегабайт скриптов и ставит cookie Google, а смотрят видео
 * немногие. По клику обложка заменяется плеером youtube-nocookie.com, и видео
 * сразу запускается.
 *
 * Обложка — обычная ссылка на ролик на YouTube: без JS она просто открывает
 * его там же, в новой вкладке.
 *
 * <div data-controller="youtube-video"
 *      data-youtube-video-id-value="3UBon3naA2o"
 *      data-youtube-video-title-value="Как вести расписание">
 *   <a href="https://www.youtube.com/watch?v=3UBon3naA2o" data-action="youtube-video#play">…</a>
 * </div>
 */
export default class YoutubeVideoController extends Controller {
  static values = {
    id: String,
    title: String,
    locale: String
  }

  play(event) {
    // Новая вкладка по ctrl/cmd-клику — как у обычной ссылки.
    if (event.metaKey || event.ctrlKey || event.shiftKey) return

    event.preventDefault()

    const params = new URLSearchParams({ autoplay: '1', rel: '0' })
    if (this.localeValue) params.set('hl', this.localeValue)

    const iframe = document.createElement('iframe')
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.idValue)}?${params}`
    iframe.title = this.titleValue
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    iframe.referrerPolicy = 'strict-origin-when-cross-origin'
    iframe.allowFullscreen = true
    iframe.className = 'absolute inset-0 size-full border-0'

    event.currentTarget.replaceWith(iframe)
    iframe.focus()
  }
}
